export default {
    investors: state => state.investors,
    investorsLoading: state => state.investorsLoading,
    investorsWithShares: state => state.investorsWithShares,
    investorTypeChoices: state => state.investorOptions?.type?.choices || [],
    investorOptionsLoading: state => state.investorOptionsLoading
};
